import script from "./InvoiceHospitalTable.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceHospitalTable.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceHospitalTable.vue?vue&type=style&index=0&id=47bf3cce&lang=css"

const __exports__ = script;

export default __exports__